import React, { useRef } from 'react';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';

export const Slider = (profs) => {
    const slideRef = useRef(null);
  return (
    <div className="slide-container">
      <Slide ref={slideRef} autoplay={true} duration={profs.time} slidesToShow={profs.count}>
        {profs.Images.map((image, index) => (
          <div className="each-slide" key={index}>
            <img src={profs.Images[index]} alt="" style={{height:`${profs.heigth}`, width:"100%"}}/>
          </div>
        ))}
      </Slide>
    </div>
  );
};